export default __webpack_public_path__ + "static/media/yes3.d376ae39.gif";